// ※ pg 결제가 아닌 심사용 (심사 이후에 사용하지 않을 예정)

import { axiosPost } from '@/api/AxiosApi';

export type inAppPaymentProps = {
  order_id: string;
  title: string;
  os: string;
  product_id: string;
  price: number;
};
export const insertInAppPayment = async (aData: inAppPaymentProps) => {
  const payload = {
    path: '/v1/point/inAppPayment',
    body: { ...aData },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
